import React from "react";
import classNames from "classnames";
import { Link } from "gatsby";

import styles from "./Nav.module.scss";

interface NavProps {
  className?: string;
}

const items = [
  {
    to: "/map",
    label: "Map",
  },
  {
    to: "/venues",
    label: "Venues",
  },
  {
    to: "/about",
    label: "About",
  },
  // {
  //   to: "/archive",
  //   label: "Archive",
  // },
  {
    to: "/contact",
    label: "Contact",
  },
];

const Nav: React.FC<NavProps> = ({ className }) => {
  return (
    <nav className={classNames(styles.nav, className)}>
      <ul>
        {items.map(item => (
          <li key={item.to}>
            <Link to={item.to}>{item.label}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export { Nav };
